<div class="placeholder-swiper">
  <div class="slider-component__title">
    <h2>&nbsp;</h2>
  </div>

  <opac-swiper [configuration]="swiperConfig">
    <opac-swiper-item *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
      <div class="placeholder-cover">
        <div class="item__img">
          <img src="/assets/cover_white_215.png" />
        </div>
      </div>
    </opac-swiper-item>
  </opac-swiper>
</div>
